import React from 'react';
import classNames from 'classnames';
import Checkbox from './Checkbox';
import { CheckboxGroupContextProvider } from './context';
const CheckboxGroup = (props) => {
    const { name, className, children, options, ...restProps } = props;
    let childrenNode = options.length
        ? options.map((option) => (React.createElement(Checkbox, { key: option.value.toString(), value: option.value, onChange: option.onChange, name: 'checkbox_group' }, option.label)))
        : children;
    const classString = classNames('checkbox-group', {
        [className]: className,
    });
    return (React.createElement("div", { className: classString },
        React.createElement(CheckboxGroupContextProvider, null, childrenNode)));
};
export default CheckboxGroup;
//# sourceMappingURL=Group.js.map